export function runUTMCookies() {
  import("./cookie_utils.js").then(cookie_utils => {
    // Track referrer by default
    let exclude = "False";
    // If on organic page (determined by base.html included),
    // check for organic tracking value
    if (document.getElementById("organic_tracking")) {
      exclude = document.getElementById("organic_tracking").content;
    }
    const params = cookie_utils.transformQueryToDict();
    let wasUpdated = false;
    let pathNameTrailingSlashTrimmed = location.pathname.replace(/\/$/, "");

    wasUpdated = cookie_utils.setUTMCookies(wasUpdated, params);
    cookie_utils.setTSCookie(wasUpdated);
    cookie_utils.setOneTimeCookie("fpv", pathNameTrailingSlashTrimmed);
    cookie_utils.setOneTimeCookie("referrer", document.referrer);
    cookie_utils.setCIDCookie(params);

    if (exclude !== "True") {
      cookie_utils.determineOrigin(
        document.referrer,
        pathNameTrailingSlashTrimmed
      );
    }
  });
}
